import React, { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../Context/GlobalState";
import { AddProjectAdminModal } from "../Modal";
import { billpunchbasicauth } from "../../utils/Credentials";
import { BASE_URL_API_TRANXT_UAT_API } from "../../utils/Constant";
import { ViewProjectadmin } from "./Salarytable";
import {
  FiSearch,
  FiPlus,
  FiLayers,
  FiPlayCircle,
  FiCheckCircle,
  FiUsers,
  FiFilter,
} from "react-icons/fi";
import { getProjectStatus } from "./projectPresentation";
import "./ProjectsManagement.css";

const Createproject = () => {
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const [data, setData] = useState([]);
  const [showaddprojectModal, setshowaddprojectModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const { password, username } = billpunchbasicauth;
  const getProjects = async (e) => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({
        firmid: user.firm_id,
        created_by: "Admin",
      });

      var requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetFirmProjects`,
        requestOptions,
      );
      const data = await res.json();
      if (data.status == "0") {
        setData(data.data);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
    }
    setTransactionLoaderState(false);
  };
  const openaddprojectModal = () => {
    setshowaddprojectModal(true);
  };

  const closeaddprojectModal = () => {
    setshowaddprojectModal(false);
  };
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };
  useEffect(() => {
    getProjects();
  }, []);
  const { accessData } = useContext(GlobalContext);
  useEffect(() => {
    // console.log("Access Data:", accessData);
  }, [accessData]);
  const [statusFilter, setStatusFilter] = useState("");
  const [showFilters, setShowFilters] = useState(false);
  const canAdd = accessData?.some((module) =>
    module.data?.some(
      (role) => role.role_name === "Add Projects" && role.access === "Y",
    ),
  );
  const statuses = [...new Set(data.map(getProjectStatus))];
  const visibleProjects = data.filter(
    (project) =>
      (!statusFilter || getProjectStatus(project) === statusFilter) &&
      `${project.project_name || ""} ${project.project_description || project.project_discription || ""} ${project.project_ownership || ""}`
        .toLowerCase()
        .includes(searchTerm.toLowerCase()),
  );
  const completed = data.filter(
    (project) => getProjectStatus(project).toLowerCase() === "completed",
  ).length;
  const active = data.filter((project) =>
    ["active", "in progress"].includes(getProjectStatus(project).toLowerCase()),
  ).length;
  const owners = new Set(
    data.map((project) => project.project_ownership?.trim()).filter(Boolean),
  ).size;
  return (
    <div className="projects-management">
      <AddProjectAdminModal
        show={showaddprojectModal}
        closeModal={closeaddprojectModal}
        getProjects={getProjects}
      />
      <header className="projects-heading mt-3">
        <div>
          <h1>{user.organization || "Company"} Projects</h1>
          {/* <p>Manage company projects, track ownership and timelines.</p> */}
        </div>
        <div className="projects-controls">
          <div className="projects-search">
            <FiSearch />
            <input
              aria-label="Search projects"
              placeholder="Search…"
              value={searchTerm}
              onChange={handleSearchChange}
            />
          </div>
          <button
            className="projects-filter-button"
            onClick={() => setShowFilters((value) => !value)}
            aria-expanded={showFilters}
          >
            <FiFilter /> Filter
          </button>
          <button
            className="projects-add-button"
            disabled={!canAdd}
            onClick={openaddprojectModal}
          >
            <FiPlus /> Add Project
          </button>
        </div>
      </header>
      {showFilters && (
        <div className="projects-filter-panel">
          <label htmlFor="projects-status">Status</label>
          <select
            id="projects-status"
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
          >
            <option value="">All Statuses</option>
            {statuses.map((status) => (
              <option key={status}>{status}</option>
            ))}
          </select>
          <button
            onClick={() => {
              setStatusFilter("");
              setSearchTerm("");
            }}
          >
            Reset
          </button>
        </div>
      )}
      {/* <div className="projects-summary">
        {[
          [
            "Total Projects",
            data.length,
            FiLayers,
            "blue",
            "All company projects",
          ],
          [
            "Active Projects",
            active,
            FiPlayCircle,
            "green",
            "Active and in progress",
          ],
          [
            "Completed Projects",
            completed,
            FiCheckCircle,
            "purple",
            "Projects marked complete",
          ],
          ["Team Owners", owners, FiUsers, "orange", "Unique project owners"],
        ].map(([label, count, Icon, tone, detail]) => (
          <div className="projects-summary-card" key={label}>
            <span className={`projects-summary-icon ${tone}`}>
              <Icon />
            </span>
            <div>
              <span>{label}</span>
              <strong>{count}</strong>
              <small>{detail}</small>
            </div>
          </div>
        ))}
      </div> */}
      <section className="projects-list-card">
        <ViewProjectadmin
          data={visibleProjects}
          searchTerm=""
          getProjects={getProjects}
        />
      </section>
    </div>
  );
};

export default Createproject;
